import { AbstractPmsApiService } from "./abstract.service";
import { PropertyProfile } from "../models";

/**
 * @class PropertyProfilePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<PropertyProfile>}
 */
export class PropertyProfilePmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/property-profile';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {PropertyProfile}
     * @protected
     */
    newModel(attributes, ...params) {

        return new PropertyProfile(attributes);
    }

    /**
     * @param {Property=} property
     * @returns {Promise.<PropertyProfile>}
     */
    get(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @param {PropertyProfile} model
     * @returns {Promise.<PropertyProfile>}
     */
    save(property, model) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, model, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/property-profile.service.js